/* eslint-disable */
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  Input,
  SimpleGrid,
  Spacer,
  Spinner,
  Stack,
  Tab,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { calendarTimeIcon } from 'icons/work-order-filter-icons'
import { STATUS } from 'features/common/status'
import { useCallback, useEffect, useState } from 'react'
import { Controller, FormProvider, useFieldArray, useForm, UseFormReturn, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BiSpreadsheet } from 'react-icons/bi'
import { calendarIcon } from 'theme/common-style'
import Select, { SelectForTimeWOSlots } from 'components/form/react-select'
import {
  defaultValuesWODetails,
  getUniqueObjectsByProperties,
  parseWODetailValuesToPayload,
  useFieldEnableDecisionDetailsTab,
  WorkOrderStatusOptions,
} from 'api/work-order'
import AssignedItems from './assigned-items'
import {
  getRemovedItems,
  getUnAssignedItems,
  useDeleteLineIds,
  LineItems,
  createInvoicePdf,
  mapToLineItems,
  useAllowLineItemsAssignment,
} from './assignedItems.utils'
import RemainingItemsModal from './remaining-items-modal'
import jsPDF from 'jspdf'
import { WORK_ORDER } from '../workOrder.i18n'
import { useUserRolesSelector } from 'utils/redux-common-selectors'
import { useFilteredVendorsV2 } from 'api/pc-projects'
import { useTrades } from 'api/vendor-details'
import { useUploadDocument } from 'api/vendor-projects'
import { CustomRequiredInput, NumberInput } from 'components/input/input'
import NumberFormat from 'react-number-format'
import { removePercentageFormat } from 'utils/string-formatters'
import { useProperty } from 'api/property'
import _ from 'lodash'
import { dateFormat, datePickerFormat } from 'utils/date-time-utils'
import numeral from 'numeral'
import { UploadFilesModal } from 'components/choose-file/multi-files-upload-modal'
import { useRef } from 'react'
import { CalendarModal } from 'features/wo-calendar/calendar-modal'
import ReactSelect from 'components/form/react-select'
import { CANCEL_WO_OPTIONS } from 'constants/index'
import { ProjectStatus } from 'types/project-details.types'

/*const CalenderCard = props => {
  return (
    <Flex>
      <Box pr={4}>
        <BiCalendar size={23} color="#4A5568" />
      </Box>
      <Box lineHeight="20px">
        <Text color="gray.700" fontWeight={500} fontSize="14px" fontStyle="normal" mb="1">
          {props.title}
        </Text>
        <Text color="gray.600" data-testid={props.testId} fontSize="14px" fontStyle="normal" fontWeight={400}>
          {props?.date || 'mm/dd/yyyy'}
        </Text>
      </Box>
    </Flex>
  )
}*/

enum DateType {
  COMPLETE_BY_VENDOR = 1,
  VERIFIED_DATE = 2,
}

const InformationCard = props => {
  return (
    <Flex>
      <Box lineHeight="20px">
        <Text color="gray.700" fontWeight={500} fontSize="14px" fontStyle="normal" mb="1">
          {props.title}
        </Text>
        <Text
          data-testid={props.testId}
          color="gray.600"
          fontSize="14px"
          fontStyle="normal"
          fontWeight={400}
          isTruncated={true}
          maxW="150px"
          title={props.date}
          {...props.customStyle}
        >
          {props.date}
        </Text>
      </Box>
    </Flex>
  )
}

interface FormValues {
  cancel: any
  workOrderStartDate: string | null
  workOrderStartTime: any
  workOrderDateCompleted: string | null
  workOrderDateVerified: string | null
  workOrderExpectedCompletionDate: string | null
  assignedItems?: LineItems[]
  vendorSkillId: number | string | null
  vendorId: number | string | null
  invoiceAmount: any
  percentage: any
  clientApprovedAmount: any
  status: any
  workOrderTimeSlots?: any
  finalInvoiceAmount?: any
  setWorkOrderFormReturn?: any
  workOrderNewAmount?: any
  subTotal?: any
}

const WorkOrderDetailTab = props => {
  const {
    workOrder,
    onSave,
    navigateToProjectDetails,
    isWorkOrderUpdating,
    swoProject,
    projectData,
    documentsData,
    workOrderAssignedItems,
    isFetchingLineItems,
    isLoadingLineItems,
    locations,
    setWorkOrderFormReturn,
  } = props
  const formReturn = useForm<FormValues>()
  const submitRef = useRef<HTMLButtonElement>(null)

  //console.log(formReturn.formState.errors);

  ;(formReturn as any).submitRef = submitRef
  setWorkOrderFormReturn(formReturn)
  const {
    register,
    control,
    reset,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = formReturn

  const assignedItemsArray = useFieldArray({
    control,
    name: 'assignedItems',
  })
  const { append } = assignedItemsArray
  const woStartDate = useWatch({ name: 'workOrderStartDate', control })
  const assignedItemsWatch = useWatch({ name: 'assignedItems', control })

  const { mutate: deleteLineItems } = useDeleteLineIds()

  const [unassignedItems, setUnAssignedItems] = useState<LineItems[]>([])
  const { isAssignmentAllowed } = useAllowLineItemsAssignment({ workOrder })
  const [uploadedWO, setUploadedWO] = useState<any>(null)
  const { mutate: saveDocument } = useUploadDocument({ hideToast: true, projectId: projectData?.id })
  const { propertyData } = useProperty(projectData?.propertyId)

  const { t } = useTranslation()
  const disabledSave = isWorkOrderUpdating || (!(uploadedWO && uploadedWO?.s3Url) && isFetchingLineItems)
  const {
    isAdmin,
    isFPM,
    isProjectCoordinator: isMaintenanceCoordinator,
    isAccounting,
    isVendor,
  } = useUserRolesSelector()
  const { isOpen: isOpenDocumentModal, onClose: onDocumentModalClose, onOpen: onDocumentModalOpen } = useDisclosure()
  const [selectedItem, setSelectedItem] = useState<any>()
  const [itemsListWithImages, setItemsListWithImages] = useState<number[]>([])

  const {
    skillName,
    companyName,
    businessEmailAddress,
    businessPhoneNumber,
    // workOrderIssueDate,
    //  dateLeanWaiverSubmitted,
    //  // datePermitsPulled,
    //  workOrderCompletionDateVariance,
  } = props.workOrder

  const formValues = useWatch({ control })
  const {
    disableCompleteByVendor,
    disableVerifiedDate,
    workOrderStartDateEnable,
    workOrderExpectedCompletionDateEnable,
  } = useFieldEnableDecisionDetailsTab({ workOrder, formValues })

  // Remaining Items handles
  const {
    onClose: onCloseRemainingItemsModal,
    isOpen: isOpenRemainingItemsModal,
    onOpen: onOpenRemainingItemsModal,
  } = useDisclosure()

  const downloadPdf = useCallback(() => {
    let doc = new jsPDF()
    createInvoicePdf({
      doc,
      assignedItems: workOrderAssignedItems,
      property: propertyData,
      projectData,
      workOrder: workOrder,
      hidePrice: false,
      onSave: saveWorkOrderDocument,
      locations,
    })
  }, [projectData, workOrder, workOrderAssignedItems, propertyData])

  const saveWorkOrderDocument = doc => {
    saveDocument(doc)
  }

  const setAssignedItems = useCallback(
    items => {
      const selectedIds = items.map(i => i.id)
      const assigned = [
        ...items.map(s => {
          return mapToLineItems(s)
        }),
      ]
      append(assigned)
      setUnAssignedItems([...unassignedItems.filter(i => !selectedIds.includes(i.id))])
    },
    [unassignedItems, setUnAssignedItems],
  )

  useEffect(() => {
    const isCompleted = assignedItemsWatch?.every(item => item.isCompleted)
    const isVerified = assignedItemsWatch?.every(item => item.isVerified && item.isCompleted)
    if (!isVerified) {
      setValue('workOrderDateVerified', null)
    }
    if (!isCompleted) {
      setValue('workOrderDateCompleted', null)
    }
    // saving indexes of items that have documents
    const indexArray = [] as number[]
    assignedItemsWatch?.forEach((item, index) => {
      if (item?.document?.length > 0) {
        indexArray.push(index)
      }
    })
    setItemsListWithImages([...indexArray])
  }, [assignedItemsWatch])

  useEffect(() => {
    if (!documentsData?.length) return
    const uploadedWO = documentsData.find(
      doc => parseInt(doc.documentType, 10) === 39 && workOrder.id === doc.workOrderId,
    )
    setUploadedWO(uploadedWO)
  }, [documentsData])

  // Enable Vendor Type and Company Name for Admin User
  const [tradeOptions, setTradeOptions] = useState([])
  const [vendorOptions, setVendorOptions] = useState([])
  const [selectedVendorId, setSelectedVendorId] = useState<any>([])

  const { data: trades } = useTrades()
  const [vendorSkillId, setVendorSkillId] = useState(workOrder?.vendorSkillId)

  const slot = formValues?.workOrderTimeSlots?.find(w => w.label === formValues?.workOrderStartTime?.label)?.value
  const startDate = useWatch({ control, name: 'workOrderStartDate' })

  const { vendors } = useFilteredVendorsV2(slot, vendorSkillId, startDate)
  //const queryParamsVendors = { woStartTimeId: slot, vendorSkillId: vendorSkillId, woStartDate: startDate };

  //console.log( useFilteredVendorsV2(slot, vendorSkillId, startDate) )

  const selectedVendor = vendors?.find(v => v.id === (selectedVendorId as any))
  const clientStart = projectData?.clientStartDate
  // Set Vendor Type
  const defaultSkill = {
    value: workOrder?.vendorSkillId as number,
    label: workOrder?.skillName as string,
    title: workOrder?.skillName as string,
  }

  // Set Vendor Names
  const defaultVendor = {
    value: workOrder?.vendorId as number,
    label: workOrder?.claimantName as string,
    title: workOrder?.claimantName as string,
  }

  useEffect(() => {
    const option = [] as any
    if (trades && trades?.length > 0) {
      trades?.forEach(t => {
        option.push({ label: t.skill as string, value: t.id as number })
      })
    }
    setTradeOptions(option)
  }, [trades])

  useEffect(() => {
    const option = [] as any
    if (vendors && vendors?.length > 0) {
      vendors?.forEach(v => {
        option.push({ label: v.companyName as string, value: v.id as number })
      })
    }
    setVendorOptions(option)
  }, [vendors])

  const updateWorkOrderLineItems = (deletedItems, payload) => {
    if (deletedItems?.length > 0) {
      deleteLineItems(
        { deletedIds: [...deletedItems.map(a => a.id)].join(',') },
        {
          onSuccess: () => {
            onSave(payload)
          },
        },
      )
    } else {
      onSave(payload)
    }
  }

  /* -If we have new Smart work Order items added, they will be assigned in SWO.
     -If Smart Work Order items are deleted, they will be unassigned in SWO.
     -Deleted items will be send as a comma separated list to delete api of work order
     -Updated line items will be saved in workorder 
     -If no new swo items are added or delete, assign/unassign call will not be made
     -If no new swo item is deleted, delete api will not be called
     -Save workorder will be called in all cases in the end. It will trigger refreshing workorder items and other necessary calls.
  */
  const processLineItems = lineItems => {
    const { assignments, savePayload } = lineItems
    const deleted = null
    const { assignedItems, unAssignedItems } = assignments
    updateWorkOrderLineItems(deleted, savePayload)
  }
  const onSubmit = values => {
    /* Finding out newly added items. New items will not have smartLineItemId property. smartLineItemId is present for line items that have been saved*/
    /*smartLineItemId value is null for manual items*/
    const assignedItems = [...values.assignedItems.filter(a => !('smartLineItemId' in a))]
    /* Finding out items that will be unassigned*/
    const unAssignedItems = getUnAssignedItems(formValues, workOrderAssignedItems)
    const removedItems = getRemovedItems(formValues, workOrderAssignedItems)
    const payload = parseWODetailValuesToPayload(values)

    processLineItems({ assignments: { assignedItems, unAssignedItems }, deleted: removedItems, savePayload: payload })
  }

  useEffect(() => {
    if (isLoadingLineItems || isFetchingLineItems || isWorkOrderUpdating) {
      return
    }
    if (workOrder?.id) {
      reset(defaultValuesWODetails(workOrder, defaultVendor, defaultSkill, locations))

      setValue(
        'percentage',
        numeral((workOrder.finalInvoiceAmount / workOrder.clientApprovedAmount) * 100).format('0.00'),
      )
    }
  }, [workOrder, reset, workOrderAssignedItems])

  const checkKeyDown = e => {
    if (e.code === 'Enter') e.preventDefault()
  }

  const isCancelled = workOrder.statusLabel?.toLowerCase() === STATUS.Cancelled
  const [watchPercentage, watchUploadWO, woExpectedCompletionDate] = watch([
    'percentage',
    'uploadWO',
    'workOrderExpectedCompletionDate',
  ] as any)
  /*const { onPercentageChange, onApprovedAmountChange, onInvoiceAmountChange } = usePercentageAndInoviceChange({
    setValue,
  })*/
  const watchLineItems = useWatch({ name: 'assignedItems', control })
  const resetLineItemsProfit = profit => {
    formValues.assignedItems?.forEach((item, index) => {
      /*const clientAmount =
        Number(isValidAndNonEmpty(watchLineItems?.[index]?.price) ? watchLineItems?.[index]?.price : 0) *
        Number(isValidAndNonEmpty(watchLineItems?.[index]?.quantity) ? watchLineItems?.[index]?.quantity : 0)
      setValue(`assignedItems.${index}.profit`, profit)
      setValue(`assignedItems.${index}.vendorAmount`, calculateVendorAmount(clientAmount, profit))*/
    })
  }

  useEffect(() => {
    if (watchPercentage === 0) {
      resetLineItemsProfit(0)
    }
  }, [watchPercentage])

  /*useEffect(() => {
    const clientAmount = watchLineItems?.reduce(
      (partialSum, a) =>
        partialSum +
        Number(isValidAndNonEmpty(a?.price) ? a?.price : 0) * Number(isValidAndNonEmpty(a?.quantity) ? a?.quantity : 0),
      0,
    ) as any
    const vendorAmount = watchLineItems?.reduce(
      (partialSum, a) => partialSum + Number(isValidAndNonEmpty(a?.vendorAmount) ? a?.vendorAmount : 0),
      0,
    ) as any
    setValue('clientApprovedAmount', round(clientAmount, 2))
    setValue('invoiceAmount', round(vendorAmount, 2))
    setValue('percentage', round(calculateProfit(clientAmount, vendorAmount), 2))
  }, [watchLineItems])*/

  const openCalendar = () => {
    onOpenCalendarModal()
  }

  const { isOpen: isOpenCalendarModal, onClose: onCloseCalendarModal, onOpen: onOpenCalendarModal } = useDisclosure()
  const showCancelField = (isAdmin || isAccounting) && !isCancelled

  const isNewWO = workOrder?.status === WorkOrderStatusOptions.find(w => (w.label = 'NEW'))?.value
  const customValidation = (type: DateType, value: any) => {
    // HN-PSWOA-6724| This validation triggers if the date field is null but completed/verified checkboxes are all checked
    if (type === DateType.COMPLETE_BY_VENDOR) {
      const isCompleted = assignedItemsWatch?.every(item => item.isCompleted)
      if (isCompleted && !value) return 'This field is required.'
    } else {
      const isVerified = assignedItemsWatch?.every(item => item.isVerified)
      if (isVerified && !value) return 'This field is required.'
    }
  }

  return (
    <>
      <FormProvider {...formReturn}>
        <form onSubmit={formReturn.handleSubmit(onSubmit)} onKeyDown={e => checkKeyDown(e)}>
          <Stack spacing="32px" ml="15px" mr="15px">
            <Box>
              {[STATUS.Rejected].includes(workOrder?.statusLabel?.toLocaleLowerCase()) && (
                <Alert status="info" variant="custom" size="sm">
                  <AlertIcon />

                  <AlertDescription>{t(`${WORK_ORDER}.rejectedInvoiceInfo`)}</AlertDescription>
                </Alert>
              )}
            </Box>
            {!(isAdmin || isMaintenanceCoordinator || isFPM || isAccounting) ? (
              <SimpleGrid columns={5}>
                <>
                  <InformationCard testId="vendorType" title={t(`${WORK_ORDER}.vendorType`)} date={skillName} />
                  <InformationCard testId="companyName" title={t(`${WORK_ORDER}.companyName`)} date={companyName} />
                  <InformationCard testId="email" title={t(`${WORK_ORDER}.email`)} date={businessEmailAddress} />
                  <InformationCard testId="phone" title={t(`${WORK_ORDER}.phone`)} date={businessPhoneNumber} />
                </>
              </SimpleGrid>
            ) : (
              <>
                <Box mt="32px" mx="32px">
                  <HStack spacing="30px">
                    <Box w="250px" pos="relative">
                      <FormControl
                        isInvalid={!!errors.workOrderStartTime}
                        data-testid="workOrderStartTime"
                        zIndex="999"
                      >
                        <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                          Preferred Slot
                        </FormLabel>
                        <Controller
                          control={control}
                          name="workOrderStartTime"
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Box pos="relative">
                              <SelectForTimeWOSlots
                                {...field}
                                isDisabled={true}
                                options={formValues?.workOrderTimeSlots}
                                selected={field.value}
                                onChange={option => {
                                  const selectedSlot = option.value
                                  const workOrderTimeSlots = getUniqueObjectsByProperties(
                                    workOrder.clientSchedule
                                      ?.filter(w => w.preferredStartTime?.value)
                                      .map(w => {
                                        const item = _.cloneDeep(w)
                                        return {
                                          ...item.preferredStartTime,
                                          label: `${dateFormat(item.preferredStartDate)} ${
                                            item.preferredStartTime.label
                                          }`,
                                          dateLabel: `${dateFormat(item.preferredStartDate)}`,
                                          timeLabel: item.preferredStartTime.label,
                                        }
                                      }),
                                    ['value', 'dateLabel'],
                                  )

                                  setValue(
                                    'workOrderStartDate',
                                    datePickerFormat(
                                      workOrderTimeSlots.find(w => w.dateLabel === option.dateLabel).dateLabel,
                                    ),
                                  )
                                  setValue(
                                    'workOrderExpectedCompletionDate',
                                    datePickerFormat(
                                      workOrderTimeSlots.find(w => w.dateLabel === option.dateLabel).dateLabel,
                                    ),
                                  )
                                  /*setValue(
                    'workOrderExpectedCompletionDate',
                    datePickerFormat(
                      addDays(
                        new Date(
                          dateFormat(workOrderTimeSlots.find(w => w.value === option.value).dateLabel),
                        ),
                        1,
                      ),
                    )
                  )*/

                                  setValue('vendorId', null)

                                  field.onChange(option)
                                }}
                                selectProps={{ isBorderLeft: false, menuHeight: '130px' }}
                              />
                              <Box
                                pos="absolute"
                                right="15px"
                                top="50%"
                                transform="translateY(-50%)"
                                zIndex="1"
                                cursor="pointer"
                                color="#345EA6"
                                onClick={openCalendar}
                              >
                                <HStack>
                                  <Icon as={calendarTimeIcon} />
                                </HStack>
                              </Box>
                            </Box>
                          )}
                        />
                      </FormControl>
                    </Box>
                    <Box w="250px">
                      <FormControl isInvalid={!!errors.vendorSkillId} data-testid="vendorSkillId" zIndex="999">
                        <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                          Trade
                        </FormLabel>
                        <Controller
                          control={control}
                          rules={{ required: 'This is required' }}
                          name="vendorSkillId"
                          render={({ field, fieldState }) => {
                            return (
                              <>
                                <Select
                                  {...field}
                                  options={tradeOptions}
                                  size="md"
                                  value={field.value}
                                  isDisabled={true}
                                  onChange={option => {
                                    setVendorSkillId(option.value)
                                    setValue('vendorId', null)
                                    field.onChange(option)
                                  }}
                                  selectProps={{ isBorderLeft: true, menuHeight: '150px' }}
                                />
                              </>
                            )
                          }}
                        />
                      </FormControl>
                    </Box>
                    <Box w="250px" pos="relative">
                      <FormControl isInvalid={!!errors.vendorId} data-testid="vendorId" zIndex="999">
                        <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                          {t('companyName')}
                        </FormLabel>
                        <Controller
                          control={control}
                          rules={{
                            required: isNewWO ? false : 'This is required',
                          }}
                          name="vendorId"
                          render={({ field, fieldState }) => {
                            return (
                              <>
                                <Select
                                  {...field}
                                  options={vendorOptions}
                                  size="md"
                                  isDisabled={true}
                                  selectProps={{ isBorderLeft: isNewWO ? false : true, menuHeight: '150px' }}
                                  onChange={option => {
                                    setSelectedVendorId(option.value)
                                    field.onChange(option)
                                  }}
                                />
                              </>
                            )
                          }}
                        />
                      </FormControl>
                    </Box>
                    <Box w="250px">
                      <FormControl zIndex="2" isInvalid={!!errors.workOrderStartDate}>
                        <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                          {t('expectedStart')}
                        </FormLabel>
                        <Input
                          data-testid="workOrderStartDate"
                          id="workOrderStartDate"
                          type="date"
                          size="md"
                          css={calendarIcon}
                          {...(isNewWO ? {} : { variant: 'required-field' })}
                          {...register('workOrderStartDate', {
                            required: isNewWO ? false : 'This is required field.',
                          })}
                        />
                      </FormControl>
                    </Box>
                  </HStack>
                </Box>
                <>
                  <Box mt="32px" mx="32px">
                    <HStack spacing="16px" gap={'15px'}>
                      <Box w="250px">
                        <FormControl isInvalid={!!errors.workOrderExpectedCompletionDate}>
                          <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                            {t('expectedCompletion')}
                          </FormLabel>
                          <Input
                            data-testid="workOrderExpectedCompletionDate"
                            id="workOrderExpectedCompletionDate"
                            type="date"
                            size="md"
                            css={calendarIcon}
                            //isDisabled={!workOrderExpectedCompletionDateEnable}
                            {...(isNewWO ? {} : { variant: 'required-field' })}
                            {...register('workOrderExpectedCompletionDate', {
                              required: isNewWO ? false : 'This is required field.',
                            })}
                          />
                        </FormControl>
                      </Box>
                      <Box w="250px">
                        <FormControl isInvalid={!!errors?.workOrderDateCompleted}>
                          <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                            {t('completedByVendor')}
                          </FormLabel>
                          <Controller
                            control={control}
                            rules={{
                              validate: value => customValidation(DateType.COMPLETE_BY_VENDOR, value),
                            }}
                            name="workOrderDateCompleted"
                            render={({ field }) => {
                              return (
                                <Input
                                  data-testid="workOrderDateCompleted"
                                  id="workOrderDateCompleted"
                                  type="date"
                                  size="md"
                                  value={field?.value ?? ''}
                                  css={calendarIcon}
                                  isDisabled={disableCompleteByVendor}
                                  variant={isVendor ? 'outline' : 'required-field'}
                                  onChange={e => {
                                    field.onChange(e)
                                  }}
                                />
                              )
                            }}
                          />
                          <FormErrorMessage>
                            {errors?.workOrderDateCompleted && errors?.workOrderDateCompleted?.message}
                          </FormErrorMessage>
                        </FormControl>
                      </Box>
                      <Box w="250px">
                        <FormControl isInvalid={!!errors?.workOrderDateVerified}>
                          <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                            {t('verifiedDate')}
                          </FormLabel>
                          <Controller
                            control={control}
                            rules={{
                              validate: value => customValidation(DateType.VERIFIED_DATE, value),
                            }}
                            name="workOrderDateVerified"
                            render={({ field }) => {
                              return (
                                <>
                                  <Input
                                    data-testid="workOrderDateVerified"
                                    type="date"
                                    size="md"
                                    value={field?.value ?? ''}
                                    css={calendarIcon}
                                    isDisabled={disableVerifiedDate}
                                    variant={isVendor ? 'outline' : 'required-field'}
                                    onChange={e => {
                                      field.onChange(e)
                                    }}
                                  />
                                </>
                              )
                            }}
                          />
                          <FormErrorMessage>
                            {errors?.workOrderDateVerified && errors?.workOrderDateVerified?.message}
                          </FormErrorMessage>
                        </FormControl>
                      </Box>
                      <Box w="250px">
                        <FormControl zIndex="99">
                          <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                            Vendor Email
                          </FormLabel>

                          <Input
                            type="text"
                            readOnly={true}
                            isDisabled={true}
                            defaultValue={selectedVendor ? selectedVendor?.businessEmailAddress : businessEmailAddress}
                          />
                        </FormControl>
                      </Box>
                    </HStack>
                  </Box>
                </>
              </>
            )}
            <Box mt="32px" mx="32px">
              <HStack spacing="30px">
                <Box w="250px">
                  <FormControl zIndex="99">
                    <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                      Vendor Phone
                    </FormLabel>

                    <Input
                      type="text"
                      readOnly={true}
                      isDisabled={true}
                      defaultValue={selectedVendor ? selectedVendor?.businessPhoneNumber : businessPhoneNumber}
                    />
                  </FormControl>
                </Box>
                <Box w="250px">
                  <FormControl isInvalid={!!errors?.clientApprovedAmount}>
                    <FormLabel
                      noOfLines={1}
                      fontSize="14px"
                      fontWeight={500}
                      color="gray.600"
                      title={t(`${WORK_ORDER}.clientApprovedAmount`)}
                    >
                      {t(`${WORK_ORDER}.clientApprovedAmount`)}
                    </FormLabel>
                    <Controller
                      control={control}
                      rules={{
                        required: 'This field is required',
                        min: { value: 0, message: 'Enter a valid amount' },
                      }}
                      name="clientApprovedAmount"
                      render={({ field, fieldState }) => {
                        return (
                          <>
                            <NumberInput
                              value={field.value}
                              thousandSeparator
                              data-testid="clientApprovedAmount"
                              customInput={CustomRequiredInput}
                              prefix={'$'}
                              disabled={!watchUploadWO}
                              onValueChange={e => {
                                field.onChange(e.floatValue ?? '')
                                //onApprovedAmountChange(e.floatValue)
                              }}
                            />
                            <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
                          </>
                        )
                      }}
                    />
                  </FormControl>
                </Box>
                <Box w="250px">
                  <FormControl isInvalid={!!errors?.percentage}>
                    <FormLabel
                      noOfLines={1}
                      fontSize="14px"
                      fontWeight={500}
                      color="gray.600"
                      title={t(`${WORK_ORDER}.profitPercentage`)}
                    >
                      {t(`${WORK_ORDER}.profitPercentage`)}
                    </FormLabel>
                    <Controller
                      control={control}
                      rules={{ required: 'This field is required' }}
                      name={'vendorProfitPercentage' as any}
                      render={({ field, fieldState }) => {
                        return (
                          <>
                            <NumberFormat
                              value={field.value}
                              data-testid="vendorProfitPercentage"
                              customInput={CustomRequiredInput}
                              suffix={'%'}
                              onValueChange={e => {
                                field.onChange(e.floatValue ?? '')

                                //onPercentageChange(e.floatValue)
                              }}
                              onFocus={e => {
                                if (removePercentageFormat(e.target.value) === '0') {
                                  field.onChange('')
                                }
                              }}
                              onBlur={e => {
                                resetLineItemsProfit(removePercentageFormat(e.target.value))
                              }}
                              disabled={true}
                            />
                            <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
                          </>
                        )
                      }}
                    />
                  </FormControl>
                </Box>
                <Box w="250px">
                  <FormControl isInvalid={!!errors?.subTotal}>
                    <FormLabel
                      fontSize="14px"
                      fontWeight={500}
                      color="gray.600"
                      noOfLines={1}
                      title={t(`${WORK_ORDER}.vendorWorkOrderAmount`)}
                    >
                      {t(`${WORK_ORDER}.vendorWorkOrderAmount`)}
                    </FormLabel>
                    <Controller
                      control={control}
                      rules={{ required: 'This field is required' }}
                      name="subTotal"
                      render={({ field, fieldState }) => {
                        return (
                          <>
                            <NumberInput
                              value={field.value}
                              data-testid="subTotal"
                              customInput={CustomRequiredInput}
                              thousandSeparator
                              prefix={'$'}
                              disabled={!watchUploadWO}
                              onValueChange={e => {
                                field.onChange(e.floatValue ?? '')

                                //onInvoiceAmountChange(e.floatValue)
                              }}
                            />
                            <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
                          </>
                        )
                      }}
                    />
                  </FormControl>{' '}
                </Box>
              </HStack>
            </Box>
            <Box mt="32px" mx="32px" zIndex="999">
              <HStack spacing="30px">
                <Box w="230px" zIndex="2">
                  <FormControl isInvalid={!!errors?.status}>
                    <FormLabel
                      noOfLines={1}
                      fontSize="14px"
                      fontWeight={500}
                      color="gray.600"
                      title={t(`${WORK_ORDER}.status`)}
                    >
                      {t(`${WORK_ORDER}.status`)}
                    </FormLabel>
                    <Controller
                      control={control}
                      rules={{
                        required: 'This field is required',
                      }}
                      name="status"
                      render={({ field, fieldState }) => {
                        return (
                          <>
                            <Select
                              {...field}
                              isDisabled={true}
                              options={WorkOrderStatusOptions}
                              rules={{ required: 'This is required' }}
                              size="md"
                              value={field.value}
                              onChange={option => {
                                field.onChange(option)
                              }}
                              selectProps={{
                                menuHeight: '150px',
                                isBorderLeft: true,
                              }}
                            />
                            <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
                          </>
                        )
                      }}
                    />
                  </FormControl>
                </Box>
                {showCancelField && (
                  <Box w="230px">
                    <FormControl>
                      <FormLabel variant="strong-label" size="md">
                        {t('cancelWorkOrder')}
                      </FormLabel>
                      <Controller
                        control={control}
                        name="cancel"
                        render={({ field }) => (
                          <>
                            <Select
                              {...field}
                              isDisabled={[
                                STATUS.Approved,
                                STATUS.Closed,
                                STATUS.Invoiced,
                                STATUS.Rejected,
                                STATUS.Paid,
                              ].includes(workOrder.statusLabel?.toLocaleLowerCase())}
                              options={CANCEL_WO_OPTIONS}
                              size="md"
                              value={field.value}
                              onChange={option => {
                                field.onChange(option)
                              }}
                            />
                          </>
                        )}
                      />
                    </FormControl>
                  </Box>
                )}
              </HStack>
            </Box>
            <Box position="relative">
              <Text
                fontWeight="500"
                color="#4A5568"
                fontSize="16px"
                width="120px"
                position="absolute"
                zIndex="2"
                bg="#fff"
                top="-13px"
              >
                Resident Info
              </Text>
              <Divider borderColor="#CBD5E0" />
            </Box>
            <Box mt="32px" mx="32px">
              <HStack spacing="30px">
                <Box w="227px">
                  <FormControl zIndex="99">
                    <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                      Name
                    </FormLabel>

                    <Input
                      type="text"
                      readOnly={true}
                      isDisabled={true}
                      value={`${propertyData?.residents[0]?.firstName} ${propertyData?.residents[0]?.lastName}`}
                    />
                  </FormControl>
                </Box>

                <Box w="227px">
                  <FormControl zIndex="99">
                    <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                      {t(`${WORK_ORDER}.email`)}
                    </FormLabel>

                    <Input
                      type="text"
                      readOnly={true}
                      isDisabled={true}
                      value={propertyData?.residents[0]?.emailAddress}
                    />
                  </FormControl>
                </Box>

                <Box w="227px">
                  <FormControl zIndex="99">
                    <FormLabel fontSize="14px" fontWeight={500} color="gray.600">
                      {t(`${WORK_ORDER}.phone`)}
                    </FormLabel>

                    <Input
                      type="text"
                      readOnly={true}
                      isDisabled={true}
                      value={propertyData?.residents[0]?.phoneNumber}
                    />
                  </FormControl>
                </Box>
              </HStack>
            </Box>
          </Stack>

          <Box mx="14px" mt={10}>
            {isLoadingLineItems ? (
              <Center>
                <Spinner size={'lg'} />
              </Center>
            ) : (
              <Box mx="6px" mt={5}>
                <AssignedItems
                  isLoadingLineItems={isFetchingLineItems || isLoadingLineItems}
                  formControl={formReturn as UseFormReturn<any>}
                  assignedItemsArray={assignedItemsArray}
                  isAssignmentAllowed={isAssignmentAllowed}
                  swoProject={swoProject}
                  downloadPdf={downloadPdf}
                  workOrder={workOrder}
                  itemsListWithImages={itemsListWithImages}
                  onDocumentModalOpen={(e, index) => {
                    setSelectedItem(index)
                    onDocumentModalOpen()
                  }}
                />
              </Box>
            )}
          </Box>

          <Box borderTop="1px solid #CBD5E0" p={5} mt="40px">
            <HStack justifyContent="start" w="100%">
              {navigateToProjectDetails && (
                <Button
                  variant="outline"
                  colorScheme="brand"
                  size="md"
                  onClick={navigateToProjectDetails}
                  leftIcon={<BiSpreadsheet />}
                >
                  {t('seeDetails')}
                </Button>
              )}

              <Spacer />
              <Button data-testid="updateBtn" colorScheme="brand" type="submit" disabled={disabledSave} ref={submitRef}>
                {t('save')}
              </Button>
            </HStack>
            <HStack spacing="16px" w="100%" justifyContent="end">
              <Button
                data-testid="wo-cancel-btn"
                onClick={props.onClose}
                colorScheme="brand"
                variant="outline"
                display="none"
              >
                {t('cancel')}
              </Button>
            </HStack>
          </Box>
        </form>
      </FormProvider>

      <RemainingItemsModal
        isAssignmentAllowed={isAssignmentAllowed}
        isOpen={isOpenRemainingItemsModal}
        onClose={onCloseRemainingItemsModal}
        setAssignedItems={setAssignedItems}
        isLoading={false}
      />

      <CalendarModal
        isOpen={isOpenCalendarModal}
        onClose={onCloseCalendarModal}
        workOrder={workOrder}
        workOrderFormReturn={formReturn}
      />
      {isOpenDocumentModal && (
        <UploadFilesModal
          isOpen={isOpenDocumentModal}
          documentTypes={[{ value: 'images', label: 'Images' }]}
          onClose={() => {
            setSelectedItem(null)
            onDocumentModalClose()
          }}
          handleUpload={files => {
            setValue(`assignedItems.${selectedItem}.document`, files.length > 0 ? [...files] : [])
            setSelectedItem(null)
            onDocumentModalClose()
          }}
          uploadedFiles={getValues()?.assignedItems?.[selectedItem]?.document ?? []}
        />
      )}
    </>
  )
}

export default WorkOrderDetailTab
